import React, { useEffect } from "react";
import Button from "components/Button/Button";
import {
  disablePageScroll,
  enablePageScroll,
  classNameConditional,
} from "utils/commonMethods";
import PropTypes from "prop-types";
import "components/AlertModal/AlertModal.css";

function AlertModal({
  open,
  modalTitle,
  modalDescription,
  closeHandler,
  submitHandler,
  children,
  className: customClassName = "",
}) {
  const componentTexts = window.appTexts.components.alert_popup;
  let parentClassName = "alert-modal " + customClassName;

  useEffect(() => {
    if (open) {
      //Disable scroll
      disablePageScroll();
    } else {
      //Enable scroll
      enablePageScroll();
    }
  }, [open]);

  //Appends class to show modal on screen.
  if (open) {
    parentClassName += " show-modal";
  }

  return (
    <div className={classNameConditional(open, "transparent-overlay")}>
      <div className={parentClassName}>
        <div className="alert-modal__title">
          <h3 className="main-head"> {modalTitle}</h3>
        </div>
        <div className="alert-modal__description text-muted">
          <span> {modalDescription}</span>
        </div>
        {closeHandler && (
          <div className="alert-modal__actions">
            <Button onClick={closeHandler}>
              {componentTexts.cancel_button_text}
            </Button>
            <Button onClick={submitHandler}>
              {componentTexts.confirmation_button_text}
            </Button>
          </div>
        )}
        {children}
      </div>
    </div>
  );
}

AlertModal.propTypes = {
  open: PropTypes.bool.isRequired,
  modalTitle: PropTypes.string.isRequired,
  modalDescription: PropTypes.string.isRequired,
  closeHandler: PropTypes.func,
  submitHandler: PropTypes.func,
  className: PropTypes.string,
};

export default AlertModal;
